import script from "./QRPopup.vue?vue&type=script&setup=true&lang=ts"
export * from "./QRPopup.vue?vue&type=script&setup=true&lang=ts"

import "./QRPopup.vue?vue&type=style&index=0&id=48b342de&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48b342de"]])

export default __exports__